import { QueryConfig } from "store/utils/query-config";

export const knowledgeDocumentsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
